import React from 'react';
import { Info } from 'lucide-react';

/**
 * The population scope stated on the report's face. The deleted count comes from
 * the summary so the "including N soft-deleted" figure is live. This documents
 * the deliberate, by-design non-match with the live dashboard (which excludes
 * soft-deletes) and prevents "the numbers don't tie" confusion.
 */
const ScopeBanner = ({ summary }) => {
  const deleted = summary?.totals?.deleted ?? 0;
  return (
    <div className="flex items-start gap-2 rounded-md border border-dash-border bg-dash-muted px-3.5 py-2.5">
      <Info size={15} className="mt-0.5 flex-shrink-0 text-dash-muted-foreground" />
      <p className="text-[11px] leading-relaxed text-dash-muted-foreground">
        Covers vendors in a <span className="font-medium text-dash-foreground">terminal state (Active or Rejected)</span>,
        including <span className="font-medium text-dash-foreground">{deleted.toLocaleString()}</span> soft-deleted
        record{deleted === 1 ? '' : 's'} shown separately. In-flight (pending) vendors are excluded. Figures may differ
        from the live dashboard, which excludes deleted records.
      </p>
    </div>
  );
};

export default ScopeBanner;
